import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShieldCheck } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  const scrollToPurchase = () => {
    document.getElementById('kits')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.4
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    show: {
      opacity: 1,
      x: 0,
      transition: {
        type: 'spring',
        stiffness: 100
      }
    }
  };
  return <section className="relative pt-6 pb-10 lg:pt-8 lg:pb-14 overflow-visible px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-98">
      <div className="flex justify-center mb-6 lg:mb-8 flex-col items-center gap-4" data-id="element-99">
        <img src="https://cdn.magicpatterns.com/uploads/qJustZMxmxDKBZsGFJMSjj/LOGO_DECOEMPRENDE.png" alt="Deco Emprende Logo" className="h-24 sm:h-32 object-contain" data-id="element-100" />
        <div className="flex flex-col items-center gap-2" data-id="element-101">
          <img src="https://cdn.magicpatterns.com/uploads/qCr4pHhduQYCW62Ss2bDya/imagen_calificacion.png" alt="+600 alumnas ya forman parte" className="h-12 sm:h-16 object-contain" data-id="element-102" />
          <p className="text-sm sm:text-base text-deco-taupe font-medium text-center" data-id="element-103">
            +600 mujeres ya forman parte de Deco Emprende
          </p>
        </div>
      </div>

      <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-104">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="max-w-2xl flex flex-col items-center text-center lg:items-start lg:text-left" data-id="element-105">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl leading-[1.1] mb-6 text-deco-text font-bold flex flex-col gap-2" data-id="element-106">
            <span data-id="element-107">Aprendé a crear</span>
            <span className="text-deco-terra font-script font-normal text-5xl sm:text-6xl lg:text-7xl px-1" data-id="element-108">
              Flores Eternas
            </span>
            <span data-id="element-109">desde cero</span>
          </h1>

          <p className="text-base sm:text-lg text-deco-taupe font-medium mb-6 max-w-xl" data-id="element-110">
            Aprendé a transformar simples limpiapipas en flores que están en
            tendencia para decorar, regalar o vender desde tu casa.
          </p>

          <motion.div variants={containerVariants} initial="hidden" animate="show" className="flex flex-col gap-2 sm:gap-3 mb-8 w-full max-w-md mx-auto lg:mx-0" data-id="element-111">
            {['Ideal para principiantes', 'Materiales económicos y fáciles de conseguir', 'Incluye guía paso a paso + videos tutoriales', 'Acceso digital de por vida'].map((bullet, i) => <motion.div key={i} variants={itemVariants} className="flex items-center gap-3 sm:gap-4 bg-white/80 backdrop-blur-sm p-2.5 sm:p-3 rounded-2xl border border-deco-warm shadow-sm" data-id="element-112">
                <div className="w-6 h-6 sm:w-8 sm:h-8 rounded-full bg-deco-bg flex items-center justify-center text-deco-terra shrink-0 border border-deco-warm" data-id="element-113">
                  <span className="text-sm sm:text-base" data-id="element-114">✅</span>
                </div>
                <span className="text-deco-text font-medium text-sm sm:text-base text-left" data-id="element-115">
                  {bullet}
                </span>
              </motion.div>)}
          </motion.div>

          <div className="w-full sm:w-auto flex flex-col items-center lg:items-start" data-id="element-116">
            <motion.button onClick={scrollToPurchase} whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.97
          }} animate={{
            boxShadow: ['0px 0px 0px 0px rgba(216,154,138,0.4)', '0px 0px 0px 15px rgba(216,154,138,0)', '0px 0px 0px 0px rgba(216,154,138,0)']
          }} transition={{
            duration: 2,
            repeat: Infinity,
            repeatType: 'loop'
          }} className="w-full sm:w-auto text-base sm:text-lg px-8 py-4 sm:px-12 sm:py-5 shadow-xl rounded-full bg-deco-terra text-white font-bold transition-colors border-2 border-deco-terra/20 hover:bg-deco-terra/90 uppercase tracking-wider" data-id="element-117">
              QUIERO EMPEZAR HOY
            </motion.button>
            <div className="flex items-center gap-2 mt-3 text-xs sm:text-sm text-deco-muted font-medium text-center" data-id="element-118">
              <ShieldCheck size={16} className="shrink-0" data-id="element-119" />
              <span data-id="element-120">
                Acceso inmediato desde tu celular, tablet o computadora.
              </span>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative mt-8 lg:mt-0 px-2 sm:px-0 flex justify-center" data-id="element-121">
          <div className="absolute -top-6 -right-6 w-24 h-24 bg-deco-warm rounded-full blur-2xl -z-10" data-id="element-122"></div>
          <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-deco-sage/20 rounded-full blur-2xl -z-10" data-id="element-123"></div>

          <div className="relative rounded-[2rem] overflow-hidden shadow-2xl border-4 sm:border-8 border-white aspect-[4/5] max-w-md w-full bg-deco-card" data-id="element-124">
            <video src="https://cdn.magicpatterns.com/uploads/aEWZfp3rTUHpPKBmfLRMAe/IMG_7852.MP4" autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-125" />
          </div>

          <div className="absolute -bottom-4 right-4 sm:right-10 bg-white text-deco-text px-4 py-2 rounded-xl shadow-xl border border-deco-warm font-bold text-sm flex items-center gap-2 transform rotate-3" data-id="element-126">
            <span data-id="element-127">Aprendés</span>
            <span className="text-deco-terra" data-id="element-128">•</span>
            <span data-id="element-129">Creás</span>
            <span className="text-deco-terra" data-id="element-130">•</span>
            <span data-id="element-131">Vendés</span>
          </div>
        </motion.div>
      </div>
    </section>;
}